import {
  HttpReadWriteStore,
  ProfileProjectionSelectQueryBuilder,
  ProjectionEntityStore,
  ResourceRequestOptions,
} from '@soniq/public-resource'
import {
  profileSchema,
  ProfileSchema,
} from '@soniq/schema-connection'
import { Optional } from '@pogokid/util'
import { isUuid } from '@pogokid/util/lodash'

export class ProfileHttpStore extends HttpReadWriteStore<ProfileSchema> {
  static new() {
    return new ProfileHttpStore(
      'profile',
      profileSchema.validateFn
    )
  }

  async fetchProfileByHandle(
    options: ResourceRequestOptions,
    profileId: string
  ) {
    return this.fetchById(options, profileId, profileId)
  }

  async requestHandleAction(
    options: ResourceRequestOptions,
    profileId: string,
    data: { handle: string }
  ) {
    return this.action(options, profileId, {
      data: {
        type: 'request_handle',
        ...data,
      },
    })
  }
}

export class ProfileProjectionStore extends ProjectionEntityStore<ProfileSchema> {
  static new() {
    return new ProfileProjectionStore('profile', profileSchema)
  }

  andWithHandle(
    queryBuilder: ProfileProjectionSelectQueryBuilder<'profile'>,
    userId: string,
    handle: string
  ) {
    if (handle === 'me') {
      return queryBuilder.where('id', '=', userId)
    } else if (handle) {
      return queryBuilder.where('handle', '=', handle)
    }
    return queryBuilder
  }

  profileByHandleQuery(
    options: ResourceRequestOptions,
    userId: string,
    handle: Optional<string>
  ) {
    const query = this.getDb(options)
      .selectFrom('profile')
      .selectAll() as unknown as ProfileProjectionSelectQueryBuilder<'profile'>

    if (handle === 'me') {
      return query.where('id', '=', userId).limit(1)
    } else if (isUuid(handle)) {
      return query.where('id', '=', handle).limit(1)
    } else if (handle) {
      return query.where('handle', '=', handle).limit(1)
    } else {
      return query.where('id', '=', userId).limit(1)
    }
  }
}
